module.exports = __webpack_public_path__ + "static/polygon-horizontal.4b05dad41a73250f37c3a707f36d30a8.svg";